import { ColDef } from "ag-grid-enterprise";

export const exportCurrentIIP = (
  distiView: any,
  accountViewList: any,
  accounTotalView: any,
  distiAccountView: any,
  itemsList: any,
  baseHeader: any,
  Workbook: any,
  fs: any
) => {
  const distiUIList = JSON.parse(
    JSON.stringify(distiView.baseAgGrid.baseGrid.uiList)
  );
  let accountsList: any[] = [];
  accountViewList._results.forEach((account: any) => {
    accountsList.push(
      ...JSON.parse(JSON.stringify(account.baseAgGrid.baseGrid.uiList))
    );
  });
  const totalAccList = JSON.parse(
    JSON.stringify(accounTotalView.baseAgGrid.baseGrid.uiList)
  );
  const distiAccList = JSON.parse(
    JSON.stringify(distiAccountView.baseAgGrid.baseGrid.uiList)
  );
  let mergedUIList = [
    ...distiUIList.filter((row:any)=>row.checked),
    ...accountsList.filter((row:any)=>row.checked),
    ...totalAccList.filter((row:any)=>row.checked),
    ...distiAccList.filter((row:any)=>row.checked),
  ];
  const itemLabel =  distiView.baseAgGrid.selectedNavProduct ? distiView.baseAgGrid.selectedNavProduct.label || distiView.baseAgGrid.selectedNavProduct.label: 'All Item(s)';
  const currentItem: any = itemsList.find(
    (row: any) => row.label == itemLabel
  );
  mergedUIList.forEach((row: any) => {
    row.itemName = currentItem ? currentItem.key : '';
    row.description = currentItem ? currentItem.name : '';
    row.channelId = '';
    row.account = row.currentAccount ? row.currentAccount.salesforceId : '';
    row.accountName = row.currentAccount ? row.currentAccount.accountName : '';
    (row.type = row.currentAccount ? 'Account' : 'Distributor'),
      (row.distributorName = row.selectedDistibutor
        ? row.selectedDistibutor.distributorName
        : ''),
      (row.salesforceId = row.selectedDistibutor
        ? row.selectedDistibutor.distributoR_SFID
        : row.currentAccount.salesforceId);
  });
  const columns = getIIPColumnDefs();
  const columnDefs = distiView.baseAgGrid.baseGrid.gridApi
    .getColumnDefs()
    ?.filter((row: any) => row.headerName && !row.hide);
  if (columnDefs && columnDefs.length > 0) {
    columnDefs.forEach((el: ColDef) => {
      const calendar = {
        header: el.headerName,
        key: el.headerName,
        width: 20,
        style: {
          numFmt: '#,##',
          border: {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          },
        },
      };
      columns.push(calendar as any);
    });
  }
  mergedUIList.forEach((row: any) => {
    Object.keys(row).forEach((key) => {
      if (
        row['code'].indexOf('Pct') > -1 && row[key] !== 'Multiple %' &&
        distiView.baseAgGrid.baseGrid.selectedTimeframe.includes(key)
      ) {
        row[key] = parseFloat(row[key]) || 0;
        if (!isNaN(row[key])) {
          row[key] = row[key] / 100;
        }
      } else if ( row['code'].indexOf('Comment') < 0 &&
      distiView.baseAgGrid.baseGrid.selectedTimeframe.includes(key) && row[key] !== 'Multiple') {
        row[key] = Math.round(+row[key].toString().replaceAll(',', ''));
      }
    });
  });
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('RETAIL_INDIRECT');
  worksheet.columns = columns as any;
  mergedUIList.forEach((e) => {
    const row = worksheet.addRow(e, 'n');
    if (e.code && e.code.indexOf('Pct') > -1) {
      columnDefs.forEach((_el: ColDef, colIndex: number) => {
        const cellIndex = colIndex + 8; // 7 fixed columns + 1 for 1-based indexing
        const cell = row.getCell(cellIndex);
        cell.numFmt = '0.00%';
      });
    }
  });
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    fs.saveAs(blob, `Forecast${new Date().toISOString()}.xlsx`);
  });
  return true;
};
export const getIIPColumnDefs = () => {

  const columns = [
    {
      header: 'Measure',
      key: 'measureName',
      width: 50,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'SKU',
      key: 'itemName',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Description',
      key: 'description',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Disti/Account',
      key: 'type',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Distributor',
      key: 'distributorName',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'Account Name',
      key: 'accountName',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
    {
      header: 'SFID',
      key: 'salesforceId',
      width: 20,
      style: {
        border: {
          top: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        },
        fill: {
          type: 'pattern',
          gradient: 'lightGray',
          bgColor: { argb: '808080' },
        },
      },
    },
  ];
  return columns;
}
